import { AdminLegalAlertsMexicoLoading } from '@/views/admin-legal-alerts-mexico/admin-legal-alerts-mexico.loading';

export default AdminLegalAlertsMexicoLoading;
